/**
 * Travel table of the neon layer (MOTION-SPEC §4).
 *
 * Eight scenes move a diagonal light band along the painted routes; the two
 * circular compositions (learning-cycle, finale) turn a conic sector around
 * the centre of their ring instead. Angles follow CSS gradient convention
 * (0° = up, 90° = right, clockwise); centres are percentages of the canvas.
 */

import type { ReferenceSceneId } from '../../reference/types';

export type TravelSpec =
  | { kind: 'band'; angle: number; period: number }
  | { kind: 'sector'; cx: number; cy: number; period: number };

export const TRAVEL: Record<ReferenceSceneId, TravelSpec> = {
  classroom: { kind: 'band', angle: 120, period: 7000 },
  motivation: { kind: 'band', angle: 90, period: 8000 },
  'teacher-goal': { kind: 'band', angle: 45, period: 6500 },
  'knowledge-map': { kind: 'band', angle: 180, period: 7500 },
  'personal-route': { kind: 'band', angle: 70, period: 7000 },
  'learning-cycle': { kind: 'sector', cx: 48.6, cy: 49.1, period: 9000 },
  agency: { kind: 'band', angle: 0, period: 7500 },
  'teacher-workspace': { kind: 'band', angle: 135, period: 7000 },
  technology: { kind: 'band', angle: 180, period: 8000 },
  finale: { kind: 'sector', cx: 72.8, cy: 39.7, period: 10000 },
};

/** Unit vector of a CSS gradient angle in screen space (x right, y down). */
export function travelVector(angle: number): { tx: number; ty: number } {
  const a = (angle * Math.PI) / 180;
  const round = (v: number) => Math.round(v * 1000) / 1000 + 0;
  return { tx: round(Math.sin(a)), ty: round(-Math.cos(a)) };
}

/** Power-on runs 280–740 ms after the scene lands; travel resumes when it ends. */
export const TRAVEL_RESUME_MS = 740;
